import { ArrowIcon } from "../../../../../../shared/infrastructure";
import React from "react";
import { Select } from "../../../../../../shared/infrastructure/ui";
import { SelectComponentProps } from "./types";
import { useInfiniteGetOrders } from "../../../services";
import { withSelectOptions } from "./with-select-options";
import { OrderT, UseGetOrdersFilters } from "../../../../domain/entities";

type RenderOption = {
  option: OrderT;
  value?: Array<OrderT> | OrderT;
};

const RenderOption = ({ option, value }: RenderOption): React.ReactElement => {
  return (
    <section className="grid min-w-[300px] grid-cols-[10px_60px_1fr_10px_1fr] items-center gap-[8px] text-[12px]">
      <section>
        {value &&
        !Array.isArray(value) &&
        value?.orderNumber === option.orderNumber ? (
          <ArrowIcon width={10} height={10} className="-rotate-90" />
        ) : (
          <span className="block h-[10px] w-[10px]" />
        )}
      </section>
      <span className="overflow-hidden text-ellipsis whitespace-nowrap text-[#838383]">
        {option?.orderNumber}
      </span>
      <span className="font-[700] text-[#000000]">
        {option.loads_origin.city},{" "}
        {option.loads_origin.state_code ?? option.loads_origin.state_id}
      </span>
      <ArrowIcon width={10} height={10} className="-rotate-90" />
      <span className="overflow-hidden text-ellipsis whitespace-nowrap font-[700] text-[#000000]">
        {option.loads_destination.city},{" "}
        {option.loads_destination.state_code ??
          option.loads_destination.state_id}
      </span>
    </section>
  );
};

const OrderSelectComponent = ({
  placeholder,
  name = "",
  selectedValue,
  onChangeValue,
  error = "",
  variant = "standard",
  disabled = false,
  handleSetKeyword,
  isLoading,
  getNextPage,
  noMore,
  data,
  noError,
  labelProp = "orderNumber",
  keyword,
  multiselect,
  required,
}: SelectComponentProps<OrderT>): React.ReactElement => {
  return (
    <Select<OrderT>
      isNumeric
      searchValue={keyword}
      multiselect={multiselect}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      options={data}
      name={name}
      asyncFilter={handleSetKeyword}
      labelProp={labelProp}
      value={selectedValue}
      onChange={onChangeValue}
      noMore={noMore}
      getMore={getNextPage}
      renderOptionComponent={(option: OrderT) => (
        <RenderOption option={option} value={selectedValue} />
      )}
      error={error}
      variant={variant}
      noError={noError}
      required={required}
    />
  );
};

export const OrderSelect = withSelectOptions<OrderT, UseGetOrdersFilters>(
  OrderSelectComponent,
  useInfiniteGetOrders,
  "s"
);
